// Print-only twin of the payments grid. A real table, unlike the flex rows on
// screen: the browser repeats <thead> on every page of a long report

import { PaymentPurposes } from '../utils/enums';
import './PaymentsListPDF.scss';

// The plain-text twin of the grid's Description column
const description = ({ purpose, teamName, tournamentName }) => {
  switch (purpose) {
    case PaymentPurposes.TOURNAMENT:
      return `For the ${teamName} team to participate in the ${tournamentName} tournament`;
    case PaymentPurposes.CARD:
      return "Player's card";
    default:
      return '';
  }
};

export default function PaymentsListPDF({ rows, title, generatedAt }) {
  // Dollar amounts add up to float noise ($285.30000000000004 otherwise)
  const total = Number(
    rows.reduce((sum, { amount }) => sum + (Number(amount) || 0), 0).toFixed(2),
  );

  return (
    <div className='payments-list-pdf'>
      <h4 className='title'>{title}</h4>
      <table>
        <thead>
          <tr>
            <th className='col-date'>Date</th>
            <th className='col-method'>Method</th>
            <th className='col-id'>ID</th>
            <th className='col-description'>Description</th>
            <th className='col-amount'>Amount</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td className='col-date'>{row.dateLabel}</td>
              <td className='col-method'>{row.method}</td>
              <td className='col-id'>{row.id}</td>
              <td className='col-description'>{description(row)}</td>
              <td className='col-amount'>{'$' + row.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className='total'>
        <p>{`${rows.length} payment${rows.length === 1 ? '' : 's'}`}</p>
        <p className='font-medium'>{'Total: $' + total}</p>
      </div>
      <p className='generated'>{`Generated: ${generatedAt}`}</p>
    </div>
  );
}
